import React, { useContext } from "react";
import { AuthContext } from "../utilities/contexts";
import MainRouter from "./MainRouter";
import UtilityRouter from "./UtilityRouter";
import LicensePicker from "../pages/components/LicensePicker/LicensePicker";
import "./AuthRouter.css";

export default function AuthRouter() {
   const auth = useContext(AuthContext);
   //If logged in (have credentials), navigate to main router, otherwise utility router.
   if (auth.credentials && !auth.license) {
      return (
         <div className="license-picker-page">
            <LicensePicker />
         </div>
      );
   }

   if (auth.credentials && auth.license) {
      return <MainRouter />;
   }

   return <UtilityRouter />;
}
